<template>
  <div class="lines-bg">
    <page-sections :sections="page.fields.children" />
  </div>
</template>

<script>
import PageSections from '~/components/PageSections'
import EventsSchema from '~/assets/src/events-schema.json'

export default {
  components: {
    PageSections
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      localStorage.setItem('prev', from.path)
      // vm.prevRoute = from
    })
  },
  asyncData: async function({ $api }) {
    return {
      page: await $api.getPage('events'),
    }
  },
  mounted() {
    console.log(this.page)
  },
  head: function() {
    return { 
      title: `${this.page.fields.title}`,
      script: [{
        type: 'application/ld+json',
        json: EventsSchema
      }]
    }
  },
}
</script>